import { css } from "emotion";

const H2 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  maxWidth,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  id,
  style = {},
  children
}) => {
  const styles = css({
    fontWeight: 600,
    fontSize: 32,
    maxWidth: maxWidth ? maxWidth : "none",
    marginLeft: maxWidth ? "auto" : 0,
    marginRight: maxWidth ? "auto" : 0,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    [`@media(max-width: ${breakpoint}px)`]: {
      fontSize: 20,
      marginTop: marginTopMobile,
      marginBottom: marginBottomMobile
    },
    ...style
  });

  return (
    <h2 className={styles} id={id}>
      {children}
    </h2>
  );
};

export default H2;
